import { Input } from '@cian/ui-kit/input';
import { InputAdornment } from '@cian/ui-kit/inputAdornment';
import * as React from 'react';

import * as styles from './styles.css';
import { stringToNumber } from './utils/stringToNumber';

interface IPriceInputsProps {
  minValue?: number;
  maxValue?: number;
  min: number;
  max: number;
  minTestId: string;
  maxTestId: string;
  onMinChange(value: number | null): void;
  onMaxChange(value: number | null): void;
  onMinBlur: () => void;
  onMaxBlur: () => void;
}

export const PriceInputs = React.forwardRef<HTMLDivElement, IPriceInputsProps>(
  ({ minValue, maxValue, min, max, minTestId, maxTestId, onMinChange, onMaxChange, onMinBlur, onMaxBlur }, ref) => {
    const handleKeyDown = React.useCallback((event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        (event.currentTarget as HTMLInputElement).blur();
      }
    }, []);

    const createNumericInputHandler = React.useCallback(
      (onChange: (value: number | null) => void) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const numericValue = stringToNumber(event.target.value);

        onChange(numericValue);
      },
      [],
    );

    return (
      <div className={styles['container']}>
        <div data-testid={minTestId}>
          {/* Не используем NumberInput тк в нем есть баг, нельзя сделать сброс поля через value = 0 | undefined */}
          <Input
            placeholder="от"
            value={minValue?.toLocaleString('ru-RU') || ''}
            min={min}
            max={max}
            onChange={createNumericInputHandler(onMinChange)}
            rightAdornment={<InputAdornment>₽</InputAdornment>}
            onBlur={onMinBlur}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div ref={ref} data-testid={maxTestId}>
          <Input
            placeholder="до"
            value={maxValue?.toLocaleString('ru-RU') || ''}
            min={min}
            max={max}
            onChange={createNumericInputHandler(onMaxChange)}
            rightAdornment={<InputAdornment>₽</InputAdornment>}
            onBlur={onMaxBlur}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>
    );
  },
);

PriceInputs.displayName = 'PriceInputs';
